import * as Yup from 'yup'

const EmailSchema = Yup.object({
  email: Yup.string().email('Error: Please enter a valid email "example@email.com"').required('Email is required'),
})

export type EmailValues = Yup.InferType<typeof EmailSchema>

export default EmailSchema
